import { ReactNode } from "react";
import { RenderWhen } from "../../infrastructure/components/RenderWhen";
import styles from "./FiltersPanelSection.module.scss";

interface IFiltersPanelSectionProps {
  title: string;
  icon?: string;
  /** Draws the full-width divider above the section. */
  withSeparator?: boolean;
  children: ReactNode;
}

/**
 * One titled block inside a FiltersSidePanel (e.g. "Служители", "Изтрити записи").
 */
export const FiltersPanelSection = ({
  title,
  icon,
  withSeparator = false,
  children,
}: IFiltersPanelSectionProps) => {
  return (
    <>
      <RenderWhen condition={withSeparator}>
        <div className={styles.separator} />
      </RenderWhen>

      <div className={styles.root}>
        <div className={styles.root_title}>
          <RenderWhen condition={!!icon}>
            <span className={styles.root_title_icon}>{icon}</span>
          </RenderWhen>
          {title}
        </div>

        {children}
      </div>
    </>
  );
};
